import moment from 'moment'
import { getDoc, doc } from 'firebase/firestore';
import { rsf, firestore, auth } from '../firebaseConfig'


//USAGE: readIds(db.collection('tasks', ['1','2','3']))
export async function readIds(collection, ids) {
  const read = ids.map(id => collection.doc(id).get())
  const result = await Promise.all(read)
  return result.map(v => v.data());
}


//USAGE: getCollectionData(db.collection('tasks').where('butt', '==', 'yup') )

export async function getCollectionData(collectionRef) {
  const call = await collectionRef.get()
  const data = call.map(doc => doc.data())
  return data
}

export function jobsTransformer(jobs) {
  const res = {}
  jobs.forEach(doc => {
    let obj = {
      id: doc.id,
      ...doc.data()
    }
    if (obj.event !== undefined && obj.event.startDate !== undefined) {
      obj.event.startDate = moment(obj.event.startDate)
    }
    res[obj.id] = obj
  })
  return res
}

export async function connectedAccountTransform(document) {
  let connectedCompanies = {};
  try {
    let data = document.data();
    let ids = data.connectedAccountIds;
    if (ids) {
      for (let i = 0; i < ids.length; i++) {
        let accountId = ids[i];
        let accountRef = doc(firestore, `companies/${accountId}`);
        let accountSnap = await getDoc(accountRef);
        if (accountSnap.exists()) {
          let accountData = accountSnap.data();
          connectedCompanies[accountData.id] = accountData;
        }
      }
    }
  } catch (e) {
    console.error(e);
    debugger;
  }

  return connectedCompanies;
}

export function taskListTransform(taskMap) {
  const res = {}
  let readCount = 0
  taskMap.forEach(doc => {
    readCount++
    let data = doc.data()
    for (let key of Object.keys(data)) {
      if (key === "timeStamp" || key === "dayStamp") continue;
      let item = data[key]
      item.id = key
      res[key] = item
    }
  })
  window.updateStats('app/App/LOAD_TASKS_SUCCESS_ACTION', readCount)
  return res
}

export function customerListTransform(customerMap) {
  const res = {}
  let readCOunt = 0
  customerMap.forEach(doc => {
    readCOunt++
    let data = doc.data()
    let custList = {}
    for (let key of Object.keys(data)) {
      let item = data[key]
      item.id = key
      // custList[key] = item
      // if(item.active){
      res[key] = item
      // }
    }

    // for(let x of Object.keys(custList)){
    //   let cust = custList[x]
    //   res[cust.id] = cust
    // }

  })
  window.updateStats('app/App/LOAD_CUSTOMERS_SUCCESS_ACTION', readCOunt)

  return res
}

export function simpleTransform(collection) {
  const res = {}
  collection.forEach(doc => {
    let obj = {
      id: doc.id,
      ...doc.data()
    }
    res[obj.id] = obj
  })
  return res
}

export function transformApiKeys(collection) {
  const res = {}
  collection.forEach(doc => {
    let obj = {
      id: doc.id,
      ...doc.data()
    }
    res[obj.integration] = obj
  })
  return res
}

export function collectionToList(collection) {
  const list = [];
  let i = 0;
  collection.forEach(doc => {
    list[i] = doc.data();
    i++;
  })

  return list;
}

export function collectionToMap(collection) {
  return simpleTransform(collection);
}

export function singleObjectTransform(objects) {
  let res = {}
  objects.forEach(doc => {
    res = {
      id: doc.id,
      ...doc.data()
    }
  })
  return res
}

export function documentTransform(value) {
  let obj = {
    ...value.data(),
    id: value.id
  }
  if (obj.event !== undefined) {
    obj.event.startDate = moment(obj.event.startDate)
  }
  if (obj.job !== undefined) {
    obj.job.event.startDate = moment(obj.job.event.startDate)
  }
  return obj
}

export default {
  simpleTransform,
  collectionToMap,
  singleObjectTransform,
  jobsTransformer,
  documentTransform,
  customerListTransform,
  taskListTransform,
  readIds,
  transformApiKeys,
  connectedAccountTransform,
  getCollectionData
}   